import { Helpers } from '../../helpers';
import { IDrillGroup } from '../../interfaces/idrill-group';
import { ApprovalCategory } from '../approval-category';
import { BatchProcessType } from '../batch-process-type';
import { DrillDesign } from '../drill-design';
import { DrillGroupWell } from '../drill-group-well';
import { DrilloutMethod } from '../drillout-method';
import { FracGroup } from '../frac-group';
import { GroupRelationship } from '../group-relationship';
import { Pad } from '../pad';
import { ProductionGroup } from '../production-group';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { Rig } from '../rig';
import { Scenario } from '../scenario';
import { ScenarioDrillFracOverlap } from '../scenario-drill-frac-overlap';
import { ScenarioWell } from '../scenario-well';
import { ScheduleActivity } from '../schedule-activity';

export class DrillGroupBase {
  DrillGroupId: number;
  ScenarioId: number | null;
  RigId: number | null;
  DrilloutMethodId: number | null;
  Description: string | null;
  ProcessingOrder: number;
  Lag: number;
  InternalContingent: boolean;
  InternalContingentComments: string | null;
  ExternalContingent: boolean;
  ExternalContingentComments: string | null;
  Contingent: boolean;
  ContingentComments: string | null;
  ApprovedAs: number | null;
  IsBatchDrill: boolean;
  HasSpudderRig: boolean;
  IsManuallyAdded: boolean;
  BoundsOfWells_Computed: object | null;
  CenterOfWells_Computed: object | null;
  WellHeadCenter: object | null;
  BoundsOfWellsSetDate: Date | null;
  DrillDesignId: number | null;
  BatchProcessTypeId: number | null;
  PadId: number | null;
  StartNoLaterThan: Date | null;
  StartNoEarlierThan: Date | null;
  SysActionUID: string | null;
  SysStartTime: Date;
  SysEndTime: Date;
  FirstWellStart: Date | null;
  LastWellEnd: Date | null;
  IsFromBaseScenario: boolean;
  SourceBaseScenarioDrillGroupId: number | null;
  CreationOrdinalNumber: number;
  IsAutoAdded: boolean;
  ContingencyRemovedDate: Date | null;
  IsContingentPad: boolean | null;
  IsLandReady: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillGroupWells_DrillGroup?: Array<DrillGroupWell> | null;
  ProjectDrillingParameters_DrillGroup?: Array<ProjectDrillingParameter> | null;
  ScenarioDrillFracOverlaps_DrillGroup?: Array<ScenarioDrillFracOverlap> | null;
  ScenarioWells_DrillGroup?: Array<ScenarioWell> | null;
  ScheduleActivities_DrillGroup?: Array<ScheduleActivity> | null;
  FracGroups_SourceBaseScenarioDrillGroup?: Array<FracGroup> | null;
  GroupRelationships_FromDrillGroup?: Array<GroupRelationship> | null;
  GroupRelationships_ToDrillGroup?: Array<GroupRelationship> | null;
  ProductionGroups_SourceBaseScenarioDrillGroup?: Array<ProductionGroup> | null;
  BatchProcessType?: BatchProcessType;
  DrillDesign?: DrillDesign;
  DrilloutMethod?: DrilloutMethod;
  Pad?: Pad;
  Rig?: Rig;
  Scenario?: Scenario;
  ApprovalCategory?: ApprovalCategory;

  constructor(item?: IDrillGroup) {
    if (item) {

      this.DrillGroupId = item.DrillGroupId;
      this.ScenarioId = item.ScenarioId;
      this.RigId = item.RigId;
      this.DrilloutMethodId = item.DrilloutMethodId;
      this.Description = item.Description;
      this.ProcessingOrder = item.ProcessingOrder;
      this.Lag = item.Lag;
      this.InternalContingent = item.InternalContingent;
      this.InternalContingentComments = item.InternalContingentComments;
      this.ExternalContingent = item.ExternalContingent;
      this.ExternalContingentComments = item.ExternalContingentComments;
      this.Contingent = item.Contingent;
      this.ContingentComments = item.ContingentComments;
      this.ApprovedAs = item.ApprovedAs;
      this.IsBatchDrill = item.IsBatchDrill;
      this.HasSpudderRig = item.HasSpudderRig;
      this.IsManuallyAdded = item.IsManuallyAdded;
      this.BoundsOfWells_Computed = item.BoundsOfWells_Computed;
      this.CenterOfWells_Computed = item.CenterOfWells_Computed;
      this.WellHeadCenter = item.WellHeadCenter;
      this.BoundsOfWellsSetDate = item.BoundsOfWellsSetDate ? new Date(item.BoundsOfWellsSetDate) : null;
      this.DrillDesignId = item.DrillDesignId;
      this.BatchProcessTypeId = item.BatchProcessTypeId;
      this.PadId = item.PadId;
      this.StartNoLaterThan = item.StartNoLaterThan ? new Date(item.StartNoLaterThan) : null;
      this.StartNoEarlierThan = item.StartNoEarlierThan ? new Date(item.StartNoEarlierThan) : null;
      this.SysActionUID = item.SysActionUID;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.FirstWellStart = item.FirstWellStart ? new Date(item.FirstWellStart) : null;
      this.LastWellEnd = item.LastWellEnd ? new Date(item.LastWellEnd) : null;
      this.IsFromBaseScenario = item.IsFromBaseScenario;
      this.SourceBaseScenarioDrillGroupId = item.SourceBaseScenarioDrillGroupId;
      this.CreationOrdinalNumber = item.CreationOrdinalNumber;
      this.IsAutoAdded = item.IsAutoAdded;
      this.ContingencyRemovedDate = item.ContingencyRemovedDate ? new Date(item.ContingencyRemovedDate) : null;
      this.IsContingentPad = item.IsContingentPad;
      this.IsLandReady = item.IsLandReady;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillGroupWells_DrillGroup = Helpers.createClassArray(DrillGroupWell, item.DrillGroupWells_DrillGroup);
      this.ProjectDrillingParameters_DrillGroup = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_DrillGroup);
      this.ScenarioDrillFracOverlaps_DrillGroup = Helpers.createClassArray(ScenarioDrillFracOverlap, item.ScenarioDrillFracOverlaps_DrillGroup);
      this.ScenarioWells_DrillGroup = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_DrillGroup);
      this.ScheduleActivities_DrillGroup = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_DrillGroup);
      this.FracGroups_SourceBaseScenarioDrillGroup = Helpers.createClassArray(FracGroup, item.FracGroups_SourceBaseScenarioDrillGroup);
      this.GroupRelationships_FromDrillGroup = Helpers.createClassArray(GroupRelationship, item.GroupRelationships_FromDrillGroup);
      this.GroupRelationships_ToDrillGroup = Helpers.createClassArray(GroupRelationship, item.GroupRelationships_ToDrillGroup);
      this.ProductionGroups_SourceBaseScenarioDrillGroup = Helpers.createClassArray(ProductionGroup, item.ProductionGroups_SourceBaseScenarioDrillGroup);
      this.BatchProcessType = new BatchProcessType(item.BatchProcessType);
      this.DrillDesign = new DrillDesign(item.DrillDesign);
      this.DrilloutMethod = new DrilloutMethod(item.DrilloutMethod);
      this.Pad = new Pad(item.Pad);
      this.Rig = new Rig(item.Rig);
      this.Scenario = new Scenario(item.Scenario);
      this.ApprovalCategory = new ApprovalCategory(item.ApprovalCategory);
    }
  }
}